import { Portal } from '../Portal';

import { ToastWrapper } from './ToastWrapper';
import { useToaster } from './useToaster';

export const Toaster = () => {
  const { toasts, handlers } = useToaster();

  return (
    <Portal>
      <div
        className="pointer-events-none fixed inset-x-2 inset-y-[--headerHeight] z-toast sm:inset-x-5"
        onMouseEnter={handlers.startPause}
        onMouseLeave={handlers.endPause}
      >
        {toasts.map(toast => (
          <ToastWrapper key={toast.id} toast={toast} />
        ))}
      </div>
    </Portal>
  );
};
